<div class="sign-up-container">
  <app-banner-preview [productGroup]="productGroup" [viewProductInfo]="viewProductInfo"></app-banner-preview>
  <div class="wrapper">
    <form class="form-group">
      <div class="form-desc">
        @if (!!productGroup.onboarding.sign_up_page.message_text) {
          <p class="message-text"
          [innerHtml]="productGroup.onboarding.sign_up_page.message_text | safeHtml"></p>
        }
      </div>
      <div class="form-input">
        <label>
          {{productGroup.onboarding.sign_up_page.ccid_input_label}}
        </label>
        <span>
          <input readonly type="text">
        </span>
        <label>
          {{productGroup.onboarding.sign_up_page.mobile_input_label}}
        </label>
        <span>
          <input readonly type="text">
        </span>
        @for (field of client.validation.fields; track field; let i = $index) {
          <div>
            <label>
              {{field.prompt}}
            </label>
            <span>
              <input readonly type="text" name="prompt-{{i}}">
            </span>
          </div>
        }
      </div>
      <div class="terms">
        @if (!!productGroup.consent.express_written_consent_ts_cs) {
          <p
          [innerHtml]="productGroup.consent.express_written_consent_ts_cs | safeHtml"></p>
        }
        <span>
          <input type="checkbox">
          I accept the terms and conditions
        </span>
      </div>
      <button type="submit">
        {{productGroup.onboarding.sign_up_page.submit_button_label}}
        <i aria-hidden="true" class="fa fa-angle-right"></i>
      </button>
    </form>
  </div>
</div>
